import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton, orderPickupButtonMobile } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/nw084ZLR5q5wuOJx6swW/locations/FwLWSMe6e9PzsWgfWGJq`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="95%"
                  maxWidth="320px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/nw084ZLR5q5wuOJx6swW/locations/FwLWSMe6e9PzsWgfWGJq`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  w="32vw"
                  maxWidth="300px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
